import { render, staticRenderFns } from "./tendero.vue?vue&type=template&id=b5cab778&scoped=true"
import script from "./tendero.vue?vue&type=script&lang=js"
export * from "./tendero.vue?vue&type=script&lang=js"
import style0 from "./tendero.vue?vue&type=style&index=0&id=b5cab778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cab778",
  null
  
)

export default component.exports